import MainLayout from '../views/Pages/MainLayout.vue'
import NotFound from '../views/GeneralViews/NotFoundPage.vue'
import Index from '../views/Pages/Index'
import InfoIndex from '../views/Pages/Info/Index.vue'
import InfoRules from '../views/Pages/Info/Rules.vue'
import InfoPayment from '../views/Pages/Info/Payment.vue'
import InfoSupport from '../views/Pages/Info/Support.vue'
import InfoContacts from '../views/Pages/Info/Contacts.vue'
import InfoAPI from '../views/Pages/Info/API.vue'
import Features from '../views/Pages/Features'
import Safety from '../views/Pages/Safety'
import Howto from '../views/Pages/Howto'
import Integration from '../views/Pages/Integration'
import Pricing from '../views/Pages/Pricing'

const Main = {
  path: '/',
  component: MainLayout,
  name: 'Main',
  children: [{
    path: '/home',
    name: 'Index',
    component: Index,
    meta: {
      noBodyBackground: false // Отключает фон
    }
  }, {
    path: '/features',
    name: 'Features',
    component: Features,
    meta: { noBodyBackground: false }
  }, {
    path: '/safety',
    name: 'Safety',
    component: Safety,
    meta: { noBodyBackground: false }
  }, {
    path: '/howto',
    name: 'Howto',
    component: Howto,
    meta: { noBodyBackground: false }
  }, {
    path: '/integration',
    name: 'Integration',
    component: Integration,
    meta: { noBodyBackground: false }
  }, {
    path: '/pricing',
    name: 'Pricing',
    component: Pricing
  }, {
    path: '/info',
    name: 'InfoIndex',
    component: InfoIndex
  }, {
    path: '/info/rules',
    name: 'InfoRules',
    component: InfoRules
  }, {
    path: '/info/payment',
    name: 'InfoPayment',
    component: InfoPayment
  }, {
    path: '/info/support',
    name: 'InfoSupport',
    component: InfoSupport
  }, {
    path: '/info/contacts',
    name: 'InfoContacts',
    component: InfoContacts
  }, {
    path: '/info/api',
    name: 'InfoAPI',
    component: InfoAPI
  }, {
    path: '*',
    component: NotFound
  }]
}

const routes = [
  {
    path: '/',
    redirect: '/home',
    name: 'Home'
  },
  Main,
]

export default routes
